// A tela ativa no endereço do navegador.
//
// POR QUE ISTO PASSOU A EXISTIR:
//   O shell nasceu sem router de propósito — a feature ativa é estado, e
//   `public/_redirects` manda qualquer caminho para o index.html. A decisão
//   simplificou o shell, mas o custo aparecia no uso: não dava para mandar
//   "abre o mapa do dia 05/09" para alguém, o botão Voltar do navegador saía
//   do sistema inteiro, e abrir uma tela em outra aba era impossível.
//
//   O que muda aqui é só a SINCRONIZAÇÃO com a barra de endereço. Continua não
//   havendo router: nada aqui decide o que montar, resolve permissão ou
//   conhece o NAV. Quem decide continua sendo o shell.
//
// POR QUE CAMINHO E NÃO HASH:
//   O retorno do login por OAuth usa o fragmento (`#access_token=...`) e o
//   supabase-js o consome e limpa. Um roteador de hash disputaria a mesma
//   parte da URL com ele, e a disputa seria justamente no login — o momento em
//   que ninguém quer depurar nada. O caminho está livre e o `_redirects` já
//   devolve 200 para qualquer um deles.

export interface Rota {
  /** Nome da feature, ou null quando o caminho é a raiz. */
  feature: string | null;
  params: URLSearchParams;
}

export function lerRota(): Rota {
  const partes = location.pathname.split('/').filter((p) => p !== '');
  return {
    feature: partes.length === 0 ? null : (partes[0] ?? null),
    params: new URLSearchParams(location.search),
  };
}

/**
 * Escreve a rota atual.
 *
 * `substituir` troca a entrada do histórico em vez de empilhar uma nova. É o
 * certo para o que não é navegação: o primeiro desenho, a troca de data dentro
 * do mapa e o redirecionamento de quem pediu uma tela sem ter permissão — esse
 * último empilhado faria o botão Voltar quicar entre a tela negada e a
 * alternativa, sem nunca sair do lugar.
 */
export function escreverRota(
  feature: string,
  params: Record<string, string> = {},
  substituir = false,
): void {
  const busca = new URLSearchParams(params).toString();
  const url = busca === '' ? `/${feature}` : `/${feature}?${busca}`;
  if (url === location.pathname + location.search) return;
  if (substituir) history.replaceState(null, '', url);
  else history.pushState(null, '', url);
}

/** Botão Voltar e Avançar do navegador. */
export function aoNavegar(cb: (rota: Rota) => void, signal?: AbortSignal): void {
  const opcoes = signal ? { signal } : undefined;
  window.addEventListener('popstate', () => cb(lerRota()), opcoes);
}
